import React from 'react';
import get from 'lodash/get';
import { WithMember } from '@quintype/components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { syndicatedSource, checkStoryType } from '../../../helpers/utils';
import {
  impression,
  trackPurchase,
  trackPurchaseFailed,
  // trackPurchaseSuccess,
  trackUserInteraction,
} from '../../../helpers/datalayer-utils';
import UpdateMobileNumber from '../micro-payment/update-mobile-number';
import PaymentOptions from '../../molecules/payment-options';
import LinkAccount from '../micro-payment/link-account';
import PaymentError from '../micro-payment/payment-error';
import PayReadSubscribe from '../micro-payment/pay-read-subscribe';
import PaymentSuccess from '../micro-payment/payment-success';
import MoengageHelper from '../../../helpers/moengage-helper';
import Voucherify from '../../../helpers/voucherify-helper';
import { EVENT_NAMES } from '../../../constants';
import './story-payment-juspay.m.css';
import ApplyVoucher from '../../molecules/apply-voucher';
import Loader from '../../atoms/icons/loader';

const PAYMENT_TYPE = {
  simpl: 'simpl',
  paytm: 'paytm_auto_debit',
  juspay: 'juspay',
};

// todo: refactor this whole component(break it in small chunks)
class MeterCrossedSubscribeWidgetJuspay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      assetPlan: null,
      currentScreen: 'payRead',
      selectedWallet: '',
      paymentOptions: {},
      isContactUsOpen: false,
      invalidOtp: false,
      isLoading: false,
      appliedCoupon: null,
    };
    this.getSubscriptionParams = this.getSubscriptionParams.bind(this);
    this.getPrice = this.getPrice.bind(this);
    this.handleClickChangeNumber = this.handleClickChangeNumber.bind(this);
    this.handleClickPayment = this.handleClickPayment.bind(this);
    this.handleClickChangeWallet = this.handleClickChangeWallet.bind(this);
    this.handlePaySuccess = this.handlePaySuccess.bind(this);
    this.handlePayError = this.handlePayError.bind(this);
    this.setUser = this.setUser.bind(this);
    this.getAssetPlan = this.getAssetPlan.bind(this);
    this.pay = this.pay.bind(this);
    this.contactHandler = this.contactHandler.bind(this);
    this.closeContactUs = this.closeContactUs.bind(this);
    this.getAllPlans = this.getAllPlans.bind(this);
    this.payWithPaytm = this.payWithPaytm.bind(this);
    this.payWithSimpl = this.payWithSimpl.bind(this);
    this.payWithJuspay = this.payWithJuspay.bind(this);
    this.sendOtp = this.sendOtp.bind(this);
    this.linkPaytmAccount = this.linkPaytmAccount.bind(this);
    this.linkSimpleAccount = this.linkSimpleAccount.bind(this);
    this.changeWallet = this.changeWallet.bind(this);
  }

  componentDidMount() {
    global.Moengage && MoengageHelper.hardPayWallAttributes();
    global.Moengage && MoengageHelper.hardPaywallEvent();
    // piano migration check - start
    this.getAllPlans().then((products) => {
      impression(products);
    });
    // piano migration check - end
    this.props.hardPayWallEnabled();
    global.AccessType && this.getAssetPlan(this.props.story.id);
  }
  /* eslint-disable */
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.story.id !== nextProps.story.id) {
      global.AccessType && this.getAssetPlan(nextProps.story.id);
    }
    if (nextProps.member === null) {
      this.setState({
        currentScreen: 'payRead',
        selectedWallet: '',
      });
    }
  }
  setPaymentOptions = () => {
    this.setState({ isLoading: true });
    global.AccessType &&
      global.AccessType.getPaymentOptions(this.getPrice())
        .then((response) => {
          this.setState({
            isLoading: false,
            paymentOptions: response,
          });
        })
        .catch((error) => this.handlePayError(error));
  };

  /* eslint-enable */
  setUser() {
    if (!this.props.member) return null;
    if (!this.props.member.metadata || !this.props.member.metadata['phone-number']) {
      this.setState({ UpdateMobileNumber: 'Set', payOptions: false });
      return null;
    }
    this.setState(
      {
        paymentOptions: {
          paytm: false,
          simpl: false,
        },
        isLoading: true,
      },
      () =>
        global.AccessType &&
        global.AccessType.setUser({
          name: this.props.member.name,
          emailAddress: this.props.member.email,
          mobileNumber: this.props.member.metadata['phone-number'],
        }).then(this.setPaymentOptions)
    );
  }

  getAssetPlan(storyId) {
    return global.AccessType.getAssetPlans({
      id: storyId,
      type: 'story',
    }).then((response) => {
      this.setState({ assetPlan: response[0] });
    });
  }

  getAllPlans() {
    const products = [];
    const macroPlans = [];

    const getMacroPlanObject = (plan) => ({
      name: plan.title,
      id: plan.id,
      price: plan.price_cents / 100,
      brand: this.props.story['story-template'] || 'text',
      category: 'Macro Plan',
      variant: checkStoryType(this.props.story),
      quantity: '1',
    });

    const getMicroPlanObject = () => ({
      name: get(this.state.assetPlan, ['duration_unit'], ''),
      id: get(this.state.assetPlan, ['id'], ''),
      price: get(this.state.assetPlan, ['price_cents'], 0) / 100,
      brand: get(this.props.story, ['story-template'], 'text'),
      category: 'Micro Plan',
      variant: checkStoryType(this.props.story),
      quantity: '1',
    });

    const subscriptionPlansPromise =
      global.AccessType &&
      global.AccessType.getSubscriptionPlans().then((subscriptionPlans) => {
        subscriptionPlans.map((plan) => {
          products.push(getMacroPlanObject(plan));
          macroPlans.push(getMacroPlanObject(plan));
        });
        this.setState({ macroPlans: macroPlans });
      });

    const assetPlanPromise =
      global.AccessType &&
      this.getAssetPlan(this.props.story.id).then(() => {
        const microPlan = getMicroPlanObject();
        products.push(microPlan);
        this.setState({
          microPlan: microPlan,
        });
      });

    const promises = [subscriptionPlansPromise, assetPlanPromise];
    return Promise.all(promises).then(() => products);
  }

  getPrice() {
    const { assetPlan, appliedCoupon } = this.state;
    return appliedCoupon && appliedCoupon.valid
      ? get(appliedCoupon, ['discount_details', 'discounted_price_cents'])
      : assetPlan.price_cents;
  }

  getSubscriptionParams() {
    return {
      plan: Object.assign({}, this.state.assetPlan, { title: 'Bloomberg Quint' }),
      assets: [
        {
          id: get(this.props.story, ['id'], ''),
          title: get(this.props.story, ['headline'], ''),
          slug: get(this.props.story, ['slug'], ''),
        },
      ],
      type: 'dynamic_asset',
      payment: {
        payment_type: PAYMENT_TYPE[this.state.selectedWallet],
        amount_cents: this.getPrice(),
        amount_currency: get(this.state.assetPlan, ['price_currency'], 0),
      },
      coupon_code: get(this.state.appliedCoupon, ['discount_details', 'code'], ''),
    };
  }

  sendDataToDatalayer = (label, CTAId = 'NA') => {
    const { member, story } = this.props;

    const _datalayerFields = {
      event: 'FunnelEvent',
      category: 'subscription via ppa',
      action: 'buy article payment option',
      label: label,
      Dimension7: member ? 'Existing' : 'New',
      ...(member && { Dimension8: member.id }),
      Dimension22: 'Banner',
      Dimension23: 'PPA Hard Paywall',
      Dimension24: CTAId,
      Dimension51: story.headline,
      Dimension31: story['story-template'] || 'text',
      Dimension52: story.sections[0].name,
      Dimension02: story['author-name'],
    };

    trackUserInteraction({
      _datalayerFields,
      ...(label === 'success' ||
        (label === 'fail' && {
          Dimension48: label,
          Dimension49: 'success',
        })),
    });
  };

  handleClickPayment(selectedWallet) {
    const paymentOption = this.state.paymentOptions[selectedWallet];
    if (paymentOption.action === 'pay' || paymentOption.action === 'subscribe') {
      this.setState({ selectedWallet }, this.pay);
      return;
    }

    switch (selectedWallet) {
      case 'paytm':
        this.setState({ selectedWallet }, this.payWithPaytm);
        this.sendDataToDatalayer(selectedWallet);
        break;
      case 'simpl':
        this.setState({ selectedWallet }, this.payWithSimpl);
        break;
      case 'juspay':
        this.setState({ selectedWallet }, this.payWithJuspay);
        this.sendDataToDatalayer(selectedWallet);
        break;
    }
  }

  payWithPaytm() {
    const paymentOption = this.state.paymentOptions.paytm;
    if (paymentOption.action !== 'pay') {
      this.setState({ currentScreen: 'linkAccount' });
    }
    switch (paymentOption.action) {
      case 'send_otp':
        this.sendOtp();
        break;
      case 'pay':
        this.pay();
        break;
    }
  }

  payWithSimpl() {
    const paymentOption = this.state.paymentOptions.simpl;
    switch (paymentOption.action) {
      case 'link':
        this.linkSimpleAccount();
        break;
      case 'pay':
        this.pay();
        break;
    }
  }

  async sendOtp() {
    const { paymentOptions, selectedWallet } = this.state;
    this.setState({ isLoading: true });
    paymentOptions[selectedWallet] = await paymentOptions[selectedWallet].proceed();
    this.setState({
      paymentOptions,
      isLoading: false,
    });
  }

  async linkPaytmAccount(otpNumber) {
    trackUserInteraction({
      event: 'CustomEvent',
      category: 'subscription via ppa',
      action: 'link paytm',
      label: 'link account',
    });

    const { paymentOptions } = this.state;
    try {
      this.setState({ isLoading: true });
      paymentOptions.paytm = await paymentOptions.paytm.proceed(otpNumber);
      this.setState({
        invalidOtp: false,
        isLoading: false,
        paymentOptions,
        currentScreen: 'payOptions',
      });
    } catch (error) {
      this.setState({
        invalidOtp: true,
        isLoading: false,
        paymentOptions,
      });
    }
    global.Moengage &&
      MoengageHelper.walletLinkedStatusAttribute({ status: 'linked', name: 'paytm' });
  }

  async linkSimpleAccount() {
    this.setState({ isLoading: true });
    const { paymentOptions } = this.state;
    paymentOptions.simpl = await paymentOptions.simpl.proceed();
    this.setState({
      paymentOptions,
      isLoading: false,
    });
  }

  pay() {
    const { paymentOptions, selectedWallet } = this.state;
    this.setState({ isLoading: true });
    paymentOptions[selectedWallet]
      .proceed(this.getSubscriptionParams())
      .then((response) => this.handlePaySuccess(response))
      .catch((errorResponse) => this.handlePayError(errorResponse));
  }

  payWithJuspay() {
    this.setState({ isLoading: true });
    const subscriptionParams = this.getSubscriptionParams();
    this.state.paymentOptions.juspay
      .proceed(subscriptionParams)
      .then((response) => {
        response.proceed(subscriptionParams).then(
          (subscription) => {
            this.handlePaySuccess(subscription);
          },
          (errorResponse) => {
            this.handlePayError(errorResponse);
          }
        );
      })
      .catch(() => this.setState({ isLoading: false }));
  }

  handleClickChangeWallet() {
    this.setState({ currentScreen: 'payOptions', selectedWallet: '' });
  }

  handleClickChangeNumber() {
    this.setState({
      currentScreen: 'updateMobileNumber',
      numberStatus: 'Update',
    });
  }

  handlePaySuccess(successResponse) {
    const subscription = get(successResponse, ['subscription']);
    const invoice = get(subscription, ['invoices', '0'], '');
    const eventData = {
      subscription_id: get(subscription, ['id']),
      sequenced_invoice_number: get(invoice, ['sequenced_invoice_number'], ''),
      created_at: get(invoice, ['created_at'], ''),
      payment_type: get(subscription, ['payment_type']),
      article_title: get(subscription, ['dynamic_assets', '0', 'title']),
      article_price: get(subscription, ['plan_amount_cents'], 0) / 100,
      base_price: get(invoice, ['base_price'], ''),
      discount_amount: get(invoice, ['discount_details', 'discount_amount'], ''),
      discount_percentage: get(invoice, ['discount_details', 'discount_percentage'], ''),
      total_price: get(invoice, ['amount_after_discount_before_tax'], ''),
      CGST: get(invoice, ['invoice_taxes', 'CGST', 'amount'], ''),
      SGST: get(invoice, ['invoice_taxes', 'SGST', 'amount'], ''),
      payment_amount: get(subscription, ['payment_amount']),
    };
    global.Moengage && global.Moengage.track_event('Purchase_Micro_Success', eventData);
    global.Moengage &&
      MoengageHelper.ppaConvesionStoryAttribute(
        get(subscription, ['dynamic_assets', '0', 'title'])
      );

    const actionField = {
      id: get(subscription, ['payment_id']),
      affiliation: 'NA',
      revenue: get(subscription, ['payment_amount']),
      tax:
        get(invoice, ['invoice_taxes', 'CGST', 'amount'], 0) +
        get(invoice, ['invoice_taxes', 'SGST', 'amount'], 0),
      shipping: 0,
      coupon: get(subscription, ['discount_detail', 'code']) || 'NA',
    };

    const datalayerFields = {
      name: get(this.state.assetPlan, ['duration_unit'], ''),
      id: get(this.state.assetPlan, ['id'], ''),
      price: get(this.state.assetPlan, ['price_cents'], 0) / 100,
      brand: get(this.props.story, ['story-template'], 'text'),
      category: 'Micro Plan',
      variant: checkStoryType(this.props.story),
      quantity: '1',
      dimension7: 'NA',
      dimension11: 'Logged In',
      dimension12: 'Banner',
      dimension13: 'Bottom Sticky',
      dimension14: 'NA',
      dimension15: get(this.props.story, ['headline'], ''),
      dimension16: get(this.props.story, ['story-template'], 'text'),
      dimension17: get(this.props.story, ['sections', '0', 'name'], ''),
      dimension18: 'NA',
      dimension19: get(this.props.story, ['author-name'], ''),
      dimension20: (this.props.story.tags || []).map((t) => t.name).join(' | '),
      dimension21: syndicatedSource(this.props.story),
    };
    trackPurchase(actionField, datalayerFields);
    // trackPurchaseSuccess();
    global.Moengage && MoengageHelper.purchase(EVENT_NAMES.PURCHASE_MICRO, subscription, invoice);
    this.setState({ currentScreen: 'paySuccess', isLoading: false });
    setTimeout(() => this.props.updateAccess(), 4000);

    if (this.props.newSubscriptionFlow) {
      const metadata = {
        PPA_payment_method: get(subscription, ['payment_type']),
        PPA_story_bought_name: get(subscription, ['dynamic_assets', '0', 'title']),
        PPA_story_bought_section: get(this.props.story, ['sections', '0', 'name'], ''),
        PPA_story_bought_count: get(subscription, ['invoices', 'length']),
      };
      Voucherify.updateCustomerMetadata(metadata);
    }

    this.sendDataToDatalayer('success');
    Voucherify.trackEvent('article_purchase');
  }

  handlePayError(response) {
    trackPurchaseFailed();
    this.setState({
      currentScreen: 'payError',
      payErrorResponse: response,
      isLoading: false,
    });
    this.sendDataToDatalayer('fail');
  }

  contactHandler() {
    this.setState({
      isContactUsOpen: true,
    });
  }

  closeContactUs() {
    this.setState({
      isContactUsOpen: false,
    });
  }

  showApplyVoucher = () => {
    this.setState({ currentScreen: 'showApplyVoucher' });
  };

  showPaymentOption = () => {
    if (!this.props.member.metadata || !this.props.member.metadata['phone-number']) {
      this.setState({ currentScreen: 'updateMobileNumber', numberStatus: 'Add' });
    } else {
      this.setState({ currentScreen: 'payOptions' });
    }
  };

  setAppliedCoupon = (coupon) => {
    this.setState({ appliedCoupon: coupon }, () => {
      this.setPaymentOptions();
      coupon && setTimeout(() => this.setState({ currentScreen: 'payOptions' }), 2000);
    });
  };

  changeWallet = () => {
    this.setState({ selectedWallet: '' });
    this.showPaymentOption();
  };

  getScreen() {
    console.log('INSIDE GETSCREEN====>>>', this.props.showPaywall, this.state.currentScreen);
    if (this.props.showPaywall) {
      return null;
    }
    switch (this.state.currentScreen) {
      case 'payRead':
        return (
          <WithMember>
            {({ checkForMemberUpdated }) => (
              <PayReadSubscribe
                payRead={this.showPaymentOption}
                userLoggedIn={!!this.props.member}
                reloadMember={checkForMemberUpdated}
                story={this.props.story}
                assetPlan={this.state.assetPlan}
                subscribeUrl={this.props.subscribeUrl}
                macroPlans={this.state.macroPlans}
                microPlan={this.state.microPlan}
                privateMode={this.props.privateMode}
              />
            )}
          </WithMember>
        );
      case 'payOptions':
        return (
          <PaymentOptions
            showApplyVoucher={this.showApplyVoucher}
            pay={this.handleClickPayment}
            setUser={this.setUser}
            paymentOptions={this.state.paymentOptions}
            isLoading={this.state.isLoading}
            assetPlan={this.state.assetPlan}
            appliedCoupon={this.state.appliedCoupon}
            setAppliedCoupon={this.setAppliedCoupon}
            story={this.props.story}
            selectedWallet={this.state.selectedWallet}
            changeNumber={this.handleClickChangeNumber}
            mobileNumber={get(this.props.member, ['metadata', 'phone-number'], null)}
          />
        );
      case 'showApplyVoucher':
        return (
          <ApplyVoucher
            showPaymentOption={this.showPaymentOption}
            appliedCoupon={this.state.appliedCoupon}
            setAppliedCoupon={this.setAppliedCoupon}
            selectedPlan={this.state.assetPlan}
          />
        );
      case 'updateMobileNumber':
        return (
          <WithMember>
            {({ checkForMemberUpdated }) => (
              <UpdateMobileNumber
                memberId={this.props.member.id}
                payRead={this.showPaymentOption}
                reloadMember={() => {
                  this.setState({ currentScreen: 'loader' });
                  return checkForMemberUpdated();
                }}
                updateNumber={this.showPaymentOption}
                UpdateMobileNumber={this.state.numberStatus}
                mobileNumber={this.props.member.metadata['phone-number']}
              />
            )}
          </WithMember>
        );
      case 'linkAccount':
        return (
          <LinkAccount
            changeWallet={this.changeWallet}
            payNow={this.linkPaytmAccount}
            invalidOtp={this.state.invalidOtp}
            isLoading={this.state.isLoading}
          />
        );
      case 'payError':
        return (
          <PaymentError
            tryAgain={this.showPaymentOption}
            errorResponse={this.state.payErrorResponse}
            contactHandler={this.contactHandler}
            isContactUsOpen={this.state.isContactUsOpen}
            closeContactUs={this.closeContactUs}
          />
        );
      case 'paySuccess':
        return <PaymentSuccess />;
      case 'loader':
        return <Loader />;
    }
  }

  render() {
    return this.getScreen();
  }
}

MeterCrossedSubscribeWidgetJuspay.propTypes = {
  member: PropTypes.objectOf(PropTypes.any),
  story: PropTypes.objectOf(PropTypes.any).isRequired,
  updateAccess: PropTypes.func.isRequired,
  subscribeUrl: PropTypes.string,
  privateMode: PropTypes.bool.isRequired,
  hardPayWallEnabled: PropTypes.func,
  newSubscriptionFlow: PropTypes.bool,
  showPaywall: PropTypes.bool,
};

MeterCrossedSubscribeWidgetJuspay.defaultProps = {
  member: {},
};

const mapStateToProps = (state) => {
  const { member } = state;
  const featureConfig = state.qt.config.features;
  return {
    member,
    newSubscriptionFlow: featureConfig.subscription.voucherify_subscription_flow,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    hardPayWallEnabled: () => {
      dispatch({
        type: 'BQ_HARDPAYWALL_ENABLED',
      });
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MeterCrossedSubscribeWidgetJuspay);
